// extracted by mini-css-extract-plugin
export default {"base":"base___R2z_A","left":"left___g0eBz","md":"md___DwEBZ","lg":"lg___MQ6da","xl":"xl___zgJGV","alwaysRelative":"alwaysRelative___ssmFE"};